module.exports = __webpack_public_path__ + "static/media/photo_studio_01_1k.4c8387fc.hdr";